export default [
  {
    title: 'station',
    dataIndex: 'name',
    key: 'name',
  }, {
    name: 'direction',
    title: 'direction',
    dataIndex: 'direction',
  },
  {
    name: 'delete',
    title: 'delete',
    dataIndex: 'delete',
  },

];
